module.exports = __webpack_public_path__ + "f8102943b07bbb3791562f3e173311ff.svg";